module.exports = __webpack_public_path__ + "static/img/bg.0fbe320.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bg.jpg
// module id = 6VW3
// module chunks = 1